import classnames from "classnames";

import Button from "@/components/button/Button.tsx";

export enum RUMSection {
  URL = "url",
  DEVICE = "device",
  PLATFORM = "platform",
  BROWSER = "browser",
  COUNTRY = "country",
}

interface SectionBtnGroupProps {
  className?: string;
  section: RUMSection;
  onSectionChange: (section: RUMSection) => void;
}

export const SectionBtnGroup = ({className, section, onSectionChange}: SectionBtnGroupProps) => {
  const onChange = (s: RUMSection) => {
    onSectionChange(s);
  };
  return (
    <div className={classnames("btn-group btn-group-sm border", className)} role="group">
      {Object.values(RUMSection).map((value) => (
        <Button
          key={value}
          variant={"secondary"}
          className={classnames({active: section === value}, "text-capitalize")}
          onClick={() => onChange(value)}
        >
          {value}
        </Button>
      ))}
    </div>
  );
};
